import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { AxiosPromise, AxiosRequestConfig } from 'axios';

import { api } from '@/api';

export async function getAddressBookAddressbooks(
  params: openapi.AddressBookAddressbooksListQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AddressBookAddressbooksListContentOpenapi> {
  return await api.get<openapi.AddressBookAddressbooksListContentOpenapi>(
    '/address_book/addressbooks/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getAddressBookAddresses(
  params: openapi.AddressBookAddressesListQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AddressBookAddressesListContentOpenapi> {
  return await api.get<openapi.AddressBookAddressesListContentOpenapi>(
    '/address_book/addresses/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function postAddressBookAddresses(
  params: openapi.AddressBookAddressesPostQueryOpenapi,
  data: openapi.AddressBookAddressesPostBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AddressBookAddressesPostContentOpenapi> {
  return await api.post<openapi.AddressBookAddressesPostContentOpenapi>(
    '/address_book/addresses/',
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getAddressBookAddressesById(
  params: openapi.AddressBookAddressesGetQueryOpenapi,
  path: openapi.AddressBookAddressesGetPathOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AddressBookAddressesGetContentOpenapi> {
  return await api.get<openapi.AddressBookAddressesGetContentOpenapi>(
    `/address_book/addresses/${path.id}/`,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function putAddressBookAddressesById(
  params: openapi.AddressBookAddressesPutQueryOpenapi,
  path: openapi.AddressBookAddressesPutPathOpenapi,
  data: openapi.AddressBookAddressesPutBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AddressBookAddressesPutContentOpenapi> {
  return await api.put<openapi.AddressBookAddressesPutContentOpenapi>(
    `/address_book/addresses/${path.id}/`,
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function deleteAddressBookAddressesById(
  params: openapi.AddressBookAddressesDeleteQueryOpenapi,
  path: openapi.AddressBookAddressesDeletePathOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AddressBookAddressesDeleteContentOpenapi> {
  return await api.delete<openapi.AddressBookAddressesDeleteContentOpenapi>(
    `/address_book/addresses/${path.id}/`,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function putAddressBookAddressesByIdMoveTo(
  params: openapi.AddressBookAddressesMovetoQueryOpenapi,
  path: openapi.AddressBookAddressesMovetoPathOpenapi,
  data: openapi.AddressBookAddressesMovetoBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AddressBookAddressesMovetoContentOpenapi> {
  return await api.put<openapi.AddressBookAddressesMovetoContentOpenapi>(
    `/address_book/addresses/${path.id}/move_to/`,
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function putAddressBookAddressesByIdMoveUp(
  params: openapi.AddressBookAddressesMoveupQueryOpenapi,
  path: openapi.AddressBookAddressesMoveupPathOpenapi,
  data: openapi.AddressBookAddressesMoveupBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AddressBookAddressesMoveupContentOpenapi> {
  return await api.put<openapi.AddressBookAddressesMoveupContentOpenapi>(
    `/address_book/addresses/${path.id}/move_up/`,
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function putAddressBookAddressesByIdMoveDown(
  params: openapi.AddressBookAddressesMovedownQueryOpenapi,
  path: openapi.AddressBookAddressesMovedownPathOpenapi,
  data: openapi.AddressBookAddressesMovedownBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AddressBookAddressesMovedownContentOpenapi> {
  return await api.put<openapi.AddressBookAddressesMovedownContentOpenapi>(
    `/address_book/addresses/${path.id}/move_down/`,
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getAddressBookUserAddressbook(
  params: openapi.AddressBookUserAddressesListQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AddressBookUserAddressesListContentOpenapi> {
  return await api.get<openapi.AddressBookUserAddressesListContentOpenapi>(
    '/address_book/user_addressbook/',
    {
      ...requestConfig,
      params,
    },
  );
}

// Used to work under a user. An entry will be creted under the login user
export async function postAddressBookUserAddressbook(
  params: openapi.AddressBookUserAddressesPostQueryOpenapi,
  data: openapi.AddressBookUserAddressesPostBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AddressBookUserAddressesPostContentOpenapi> {
  return await api.post<openapi.AddressBookUserAddressesPostContentOpenapi>(
    '/address_book/user_addressbook/',
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getAddressBookUserAddressbookById(
  params: openapi.AddressBookUserAddressQueryOpenapi,
  path: openapi.AddressBookUserAddressPathOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AddressBookUserAddressContentOpenapi> {
  return await api.get<openapi.AddressBookUserAddressContentOpenapi>(
    `/address_book/user_addressbook/${path.id}/`,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function putAddressBookUserAddressbookById(
  params: openapi.AddressBookUserAddressPutQueryOpenapi,
  path: openapi.AddressBookUserAddressPutPathOpenapi,
  data: openapi.AddressBookUserAddressPutBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AddressBookUserAddressPutContentOpenapi> {
  return await api.put<openapi.AddressBookUserAddressPutContentOpenapi>(
    `/address_book/user_addressbook/${path.id}/`,
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function deleteAddressBookUserAddressbookById(
  params: openapi.AddressBookUserAddressDeleteQueryOpenapi,
  path: openapi.AddressBookUserAddressDeletePathOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AddressBookUserAddressDeleteContentOpenapi> {
  return await api.delete<openapi.AddressBookUserAddressDeleteContentOpenapi>(
    `/address_book/user_addressbook/${path.id}/`,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function putAddressBookUserAddressbookByIdMoveTo(
  params: openapi.AddressBookUserAddressesMovetoQueryOpenapi,
  path: openapi.AddressBookUserAddressesMovetoPathOpenapi,
  data: openapi.AddressBookUserAddressesMovetoBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AddressBookUserAddressesMovetoContentOpenapi> {
  return await api.put<openapi.AddressBookUserAddressesMovetoContentOpenapi>(
    `/address_book/user_addressbook/${path.id}/move_to/`,
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function putAddressBookUserAddressbookByIdMoveUp(
  params: openapi.AddressBookUserAddressesMoveupQueryOpenapi,
  path: openapi.AddressBookUserAddressesMoveupPathOpenapi,
  data: openapi.AddressBookUserAddressesMoveupBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AddressBookUserAddressesMoveupContentOpenapi> {
  return await api.put<openapi.AddressBookUserAddressesMoveupContentOpenapi>(
    `/address_book/user_addressbook/${path.id}/move_up/`,
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function putAddressBookUserAddressbookByIdMoveDown(
  params: openapi.AddressBookUserAddressesMovedownQueryOpenapi,
  path: openapi.AddressBookUserAddressesMovedownPathOpenapi,
  data: openapi.AddressBookUserAddressesMovedownBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AddressBookUserAddressesMovedownContentOpenapi> {
  return await api.put<openapi.AddressBookUserAddressesMovedownContentOpenapi>(
    `/address_book/user_addressbook/${path.id}/move_up/`,
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getAddressBookCustomer(
  params: openapi.AddressBookCustomerQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AddressBookCustomerContentOpenapi> {
  return await api.get<openapi.AddressBookCustomerContentOpenapi>(
    '/address_book/customer/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function putAddressBookCustomer(
  params: openapi.AddressBookCustomerUpdateAddressQueryOpenapi,
  data: openapi.AddressBookCustomerUpdateAddressBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AddressBookCustomerUpdateAddressContentOpenapi> {
  return await api.put<openapi.AddressBookCustomerUpdateAddressContentOpenapi>(
    '/address_book/customer/',
    data,
    {
      ...requestConfig,
      params,
    },
  );
}
